import { render, staticRenderFns } from "./UtilityDetailUtil.vue?vue&type=template&id=84961b96"
import script from "./UtilityDetailUtil.vue?vue&type=script&lang=js"
export * from "./UtilityDetailUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports